import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, FileText, Shield, HelpCircle } from 'lucide-react';
import Header from '../components/Header';
import { API } from '../App';

const pageConfig = {
  '/legal': { key: 'cgu', title: 'Mentions Legales & CGU', icon: FileText },
  '/privacy': { key: 'privacy', title: 'Politique de Confidentialite', icon: Shield },
  '/terms': { key: 'cgu', title: 'Conditions Generales d\'Utilisation', icon: FileText },
  '/help': { key: 'help', title: 'Aide', icon: HelpCircle },
};

const defaultContent = {
  cgu: `1. Editeur du site

Le site Tagora est edite par :
Tagora SAS
Societe par Actions Simplifiee au capital de 10 000 EUR
123 Rue de l'Innovation
75001 Paris, France
SIRET : 123 456 789 00012
RCS Paris B 123 456 789
TVA Intracommunautaire : FR12345678901

2. Directeur de la publication

Le directeur de la publication est le representant legal de Tagora SAS.

3. Hebergement

Le site est heberge par :
Emergent Agent
Services d'hebergement cloud

4. Contact

Pour toute question, vous pouvez nous contacter :
Email : contact@tagora.fr
Telephone : +33 1 23 45 67 89

5. Propriete intellectuelle

L'ensemble du contenu de ce site (textes, images, logos, marques, etc.) est protege par le droit de la propriete intellectuelle. Toute reproduction ou representation, totale ou partielle, de ce site ou de son contenu est interdite sans autorisation prealable ecrite de Tagora SAS.

6. Donnees personnelles

Conformement au Reglement General sur la Protection des Donnees (RGPD), vous disposez d'un droit d'acces, de rectification, de suppression et de portabilite de vos donnees personnelles. Pour exercer ces droits, contactez-nous a : privacy@tagora.fr

Delegue a la Protection des Donnees :
dpo@tagora.fr

7. Cookies

Ce site utilise des cookies essentiels au fonctionnement du service (authentification, panier). En naviguant sur ce site, vous acceptez l'utilisation de ces cookies.

8. Mediation

En cas de litige, le consommateur peut recourir a une mediation conventionnelle ou a tout autre mode alternatif de reglement des differends.`,
  privacy: `Politique de confidentialite

Chez Tagora, nous prenons la protection de vos donnees personnelles tres au serieux.

1. Donnees collectees
- Informations de compte (email, nom)
- Donnees de localisation (uniquement lors du scan QR, avec votre consentement)
- Historique des messages anonymes

2. Utilisation des donnees
Vos donnees sont utilisees exclusivement pour :
- Faciliter le contact entre trouveur et proprietaire
- Ameliorer nos services
- Vous envoyer des notifications liees a vos objets

3. Protection
Toutes les communications sont anonymes. Vos coordonnees ne sont jamais partagees sans votre consentement explicite.

4. Vos droits (RGPD)
Vous disposez d'un droit d'acces, rectification, suppression et portabilite. Contactez privacy@tagora.fr.`,
  help: `Aide - Comment utiliser Tagora PingMe ?

1. Creez votre compte
Inscrivez-vous gratuitement sur tagora.fr.

2. Achetez ou generez un PingMe
Rendez-vous dans la boutique pour acheter des stickers, porte-cles ou autres supports QR. Vous pouvez aussi generer un QR depuis votre dashboard.

3. Collez votre PingMe
Apposez le sticker ou attachez le porte-cles a votre objet.

4. En cas de perte
Activez le mode "Perdu" depuis votre dashboard. Toute personne qui scanne votre QR code pourra vous contacter anonymement.

5. Questions frequentes

Q: Mes coordonnees sont-elles visibles ?
R: Non, toutes les communications passent par notre messagerie anonyme.

Q: Combien de PingMes puis-je avoir ?
R: Il n'y a pas de limite sur le nombre de PingMes.

Q: Comment fonctionne la recompense ?
R: Vous pouvez definir un montant de recompense visible par le trouveur. Le paiement se fait entre vous directement.

Besoin d'aide supplementaire ? Contactez support@tagora.fr`
};

const Legal = () => {
  const location = useLocation();
  const config = pageConfig[location.pathname] || pageConfig['/legal'];
  const [content, setContent] = useState(null);
  const Icon = config.icon;

  useEffect(() => {
    axios.get(`${API}/cms/pages/${config.key}`).then(res => {
      if (res.data.content) {
        setContent(res.data.content);
      } else {
        setContent(defaultContent[config.key] || '');
      }
    }).catch(() => {
      setContent(defaultContent[config.key] || '');
    });
  }, [config.key]);

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="px-6 sm:px-8 lg:px-12 py-8">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-charcoal/70 hover:text-charcoal mb-6 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Retour a l'accueil
          </Link>

          <div className="card-brutal">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-primary w-12 h-12 rounded-full border-2 border-charcoal flex items-center justify-center">
                <Icon className="w-6 h-6 text-charcoal" />
              </div>
              <h1 className="text-2xl font-bold text-charcoal font-heading">{config.title}</h1>
            </div>

            <div className="prose prose-charcoal max-w-none">
              {content === null ? (
                <p className="text-charcoal/50">Chargement...</p>
              ) : (
                <div className="text-charcoal/70 whitespace-pre-line leading-relaxed">
                  {content}
                </div>
              )}
            </div>

            <div className="mt-8 pt-6 border-t-2 border-charcoal/10">
              <p className="text-sm text-charcoal/50">
                Derniere mise a jour : Fevrier 2026
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Legal;
